const PRODUCTION_HOSTS = new Set(['app.sawtna.app', 'www.sawtna.app', 'sawtna.onrender.com']);

/** Public production app — hide doctor/hospital self-serve entry for now. */
export function isPublicProductionHost() {
  if (typeof window === 'undefined') return false;
  return PRODUCTION_HOSTS.has(window.location.hostname);
}
